/* BlendIn mobile menu — fullscreen overlay nav.
   Sey-style: hamburger trigger opens a takeover panel with stacked links.
   Closes on X click, ESC key, or selecting any nav link. */
(function () {
  'use strict';

  var TRIGGER_SEL = '.bic-header__hamburger';
  var MENU_SEL = '#bic-mobile-menu';
  var CLOSE_SEL = '.bic-mobile-menu__close';
  var LINK_SEL = '.bic-mobile-menu__link, .bic-mobile-menu__util';
  var OPEN_CLASS = 'is-open';
  var BODY_LOCK_CLASS = 'bic-body--menu-open';
  var TRANSITION_MS = 300;

  function init() {
    var trigger = document.querySelector(TRIGGER_SEL);
    var menu = document.querySelector(MENU_SEL);
    if (!trigger || !menu) return;
    var close = menu.querySelector(CLOSE_SEL);

    function open() {
      menu.hidden = false;
      // Force a reflow so the transition applies on the next frame.
      void menu.offsetHeight;
      menu.classList.add(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add(BODY_LOCK_CLASS);
      // Move focus into the overlay (so ESC works and Tab is trapped here), but
      // to the panel itself, not the first link. Focusing a link draws a focus
      // ring on tap-open in Safari, which looks like a stray box over "COFFEE".
      // Keyboard users still get the gold focus ring once they Tab to a link.
      menu.setAttribute('tabindex', '-1');
      try { menu.focus({ preventScroll: true }); } catch (e) { menu.focus(); }
    }

    function closeMenu() {
      menu.classList.remove(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove(BODY_LOCK_CLASS);
      window.setTimeout(function () {
        menu.hidden = true;
      }, TRANSITION_MS);
      trigger.focus();
    }

    trigger.addEventListener('click', open);
    if (close) close.addEventListener('click', closeMenu);

    // Selecting any link inside the menu closes it (so navigations animate
    // out before the new page paints).
    menu.addEventListener('click', function (evt) {
      var t = evt.target.closest(LINK_SEL);
      if (t) closeMenu();
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && !menu.hidden) {
        evt.preventDefault();
        closeMenu();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
